import { render, staticRenderFns } from "./SelectListSlim.vue?vue&type=template&id=1af34835&"
import script from "./SelectListSlim.vue?vue&type=script&lang=js&"
export * from "./SelectListSlim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports